import { PlatformDependent } from '@/components/PlatformDependent'

import { OperatorViewDDE } from './OperatorView.dde'
import { OperatorViewDGE } from './OperatorView.dge'

const OperatorView = () => (
  <>
    <PlatformDependent dde>
      <OperatorViewDDE />
    </PlatformDependent>
    <PlatformDependent streaming>
      <OperatorViewDGE />
    </PlatformDependent>
  </>
)

export default OperatorView
